import React, { useState } from 'react'
import './ConsultarAlterarCaixa.scss'
import { Header, Grid, Segment, Divider, Form, Button, Icon, Table } from 'semantic-ui-react'


export default function ConsultarAlterarCaixa() {

    const [form, setForm] = useState({
        numero: ''
    })
    const [showInicio, setShowInicio] = useState(true);

    const handleChange = fieldname => event => {
        const auxForm = {
            ...form
        }
        auxForm[fieldname] = event.target.value;
        setForm(auxForm);
    }

    return (
        <div id='consultar-alterar-caixa'>
            <Segment basic verticalAlign='middle'>
                <Grid textAlign='center' style={{ height: '100vh' }} verticalAlign='middle'>
                    {showInicio === true &&
                        <Grid.Column textAlign='left' style={{ maxWidth: 400 }}>
                            <Segment raised>
                                <Header>
                                    Consultar/Alterar caixa
                                </Header>
                                <Divider />
                                <Form size='tiny'>
                                    <Form.Field>
                                        <label>N° Controle</label>
                                        <input value={form.numero} onChange={handleChange('numero')} />
                                    </Form.Field>
                                    <Divider clearing />
                                    <Button size='small' labelPosition='left' icon type='submit' primary onClick={() => { setShowInicio(false) }}>
                                        <Icon name='arrow right' />
                                        Enviar
                                </Button>
                                </Form>
                            </Segment>
                        </Grid.Column>
                    }
                    {showInicio === false &&
                        <Grid.Column textAlign='left'>
                            <Segment raised>
                                <Header>
                                    Dados do Caixa
                                </Header>
                                <Divider />
                                <Table singleLine>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>Empresa</Table.HeaderCell>
                                            <Table.HeaderCell>Nº Controle</Table.HeaderCell>
                                            <Table.HeaderCell>Nome do Caixa</Table.HeaderCell>
                                            <Table.HeaderCell>Data</Table.HeaderCell>
                                            <Table.HeaderCell>Turno</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell>Restaurante Dom Pedro 1</Table.Cell>
                                            <Table.Cell>1000</Table.Cell>
                                            <Table.Cell>Cartões - Celulares</Table.Cell>
                                            <Table.Cell>27/09/2011</Table.Cell>
                                            <Table.Cell>04</Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                </Table>
                                <Header>
                                    Valores Entregues
                                </Header>
                                <Divider />
                                <Table singleLine>
                                    <Table.Header>
                                        <Table.Row>
                                            <Table.HeaderCell>Pagamentos</Table.HeaderCell>
                                            <Table.HeaderCell>Vale-Brinde RDP</Table.HeaderCell>
                                            <Table.HeaderCell>Cartões</Table.HeaderCell>
                                            <Table.HeaderCell>Dinheiro/Cheque</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Header>
                                    <Table.Body>
                                        <Table.Row>
                                            <Table.Cell>0,00</Table.Cell>
                                            <Table.Cell>0,00</Table.Cell>
                                            <Table.Cell>0,00</Table.Cell>
                                            <Table.Cell>102,00</Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                    <Table.Footer>
                                        <Table.Row>
                                            <Table.HeaderCell textAlign='right' colspan='4'>Total Entregue: R$ 102,00</Table.HeaderCell>
                                        </Table.Row>
                                    </Table.Footer>
                                </Table>
                                <Button icon labelPosition='right' primary onClick={() => { setShowInicio(true) }}>
                                    <Icon name='arrow left' />
                                    Voltar
                                </Button>
                            </Segment>
                        </Grid.Column>
                    }
                </Grid>
            </Segment>
        </div>
    )

}